import { DetailInfoText } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/component/DetailInfoText';
import { Flex, Text } from '@mantine/core';

export const DetailRow = ({
	label,
	children,
	mt = '0rem',
}: {
	label: string;
	children: React.ReactNode;
	mt?: string;
}) => (
	<Flex direction="column" mt={mt}>
		<Text size="sm">{label}</Text>
		<DetailInfoText>{children}</DetailInfoText>
	</Flex>
);
